import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';

const StyledBadgeNotification = styled.div(() => css `
    position: relative;
    display: flex;
    align-items: center;

    ${margins}
  `);
const Badge = styled.span(({ theme: { olist: { components: { badge }, }, }, isDot, variation = 'alert', }) => css `
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 8px;

    ${isDot
    ? css `
          height: 8px;
          width: 8px;
          border-radius: ${badge.radius.dot};
          background-color: ${badge.notification.variation[variation].dot
        .background};
        `
    : css `
          height: 24px;
          padding-inline: ${badge['padding-inline']};

          font-size: ${badge['font-size']};
          line-height: ${badge['line-height']};
          font-weight: ${badge['font-weight']};

          border-radius: ${badge.radius.pill};

          background-color: ${badge.notification.variation[variation].count
        .background};
          color: ${badge.notification.variation[variation].count.color};
        `}
  `);

export { Badge, StyledBadgeNotification };
